<template>
    <div class="frame">
      <div class="number">{{ valueWithUnit }}</div>
      <div class="title">{{ titleText }}</div>
      <div class="percentage">{{ secondDataValue }}</div>
      <div class="description">{{ descText }}</div>
    </div>
  </template>
  
  <script>
  export default {
    props: {
      valueWithUnit: {
        type: String,
        required: false,
      },
      titleText: {
        type: String,
        required: false,
      },
      secondDataValue: {
        type: String,
        required: false,
      },
      descText: {
        type: String,
        required: false,
      },
    },
  };
  </script>
  
  <style scoped>
  .frame {
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    padding: 5%;
    width: 15rem;
    height: 15rem;
    border: 1px solid var(--border-color);
    border-radius: 50%;
    margin-bottom: 10px;
    background-color: var(--bg-secondary);
    box-shadow: 0 6px 10px var(--shadow-color);
  }
  
  .number {
    color: red;
    font-size: 2.5em;
    font-weight: bold;
    margin-right: 10px;
  }
  
  .title {
    flex-grow: 1;
    font-size: 1.8em;
    font-weight: bold;
  }
  
  .percentage {
    margin: 5%;
    background-color: rgb(245, 237, 8);
    border-radius: 8px;
    padding-left: 0.2rem;
    padding-right: 0.2rem;
    font-size: 1em;
    color: green;
    margin-right: 10px;
  }
  
  .description {
    margin: 5%;
    font-size: 0.9em;
    color: var(--text-tertiary);
  }
  @media (max-width: 750px) {
    .frame {
        display: flex;
        flex-direction: column;  
        gap: 12px;
        width: 8.5rem;
        height: 8.5rem;    
    }
  
    .number {
      font-size: 1rem;
    }
  
    .title {
      font-size: 0.7rem;
    }
  
    .percentage {
      font-size: 0.6rem;
    }
  
    .description {
      font-size: 0.5em;
    }
  }
  </style>  